<template>
  <app-layout>
    <div class="calendar-customized">
      <h1 class="text-2.5xl lg:text-3.5xl font-black color-black mb-6" v-show="destinyLabel">
        {{ destinyLabel }}
      </h1>
      <span class="font-black mb-2">{{$t("shared.prices_from")}}</span>
      <p class="text-center font-black mb-2">{{$t('shared.discover_offer')}}</p>
      <calendar-component @date-selected="selectTrip" :days="typeDates" :duration="parseInt(days)"
        :loading="loadingCalendar" :daysToAvaliableCalendar="7" :daysSelectedLoading="daysSelectedLoading" :extraPrice="trip && trip.extra_no_promo_price"></calendar-component>
      <div>
        <v-btn @click="handleClick" rounded elevation="0" color="secondary" :disabled="!isValid" :loading="buttonLoading"
          class="avm-btn avm-btn--large mt-8 lg:mt-12 focus:outline-none">{{ $t("shared.next") }}</v-btn>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { FETCH_TRIPS } from "../../store/destinies/action-types";
import { GET_PACK_FLIGHTS, GET_TYPE_PACK_DATES } from "../../store/nights/getter-types";
import { FETCH_INTERCONTINENTAL_FLIGHTS } from "../../store/nights/action-types";
import { GET_TRIP } from "../../store/destinies/getter-types";
import { UPDATE_PACK_FLIGHT } from "../../store/nights/mutation-types";

export default {
  computed: {
    ...mapGetters({
      typeDates: GET_TYPE_PACK_DATES,
      packFlights: GET_PACK_FLIGHTS,
      trip: GET_TRIP
    }),
    loadingCalendar() {
      return !this.typeDates.length
    }
  },
  data: () => ({
    isValid: false,
    days: null,
    buttonLoading: false,
    daysSelected: null,
    departureToken: null,
    destinyLabel: "",
    daysSelectedLoading: []
  }),
  methods: {
    async selectTrip(event) {
      const dateFrom = moment(event.dateFrom).format("YYYY-MM-DD")
      let daysRange = [];
      daysRange.push(dateFrom);
      for (let index = 1; index < this.days; index++) {
        let newDate = moment(dateFrom).add(index, 'days');
        daysRange.push(newDate.format("YYYY-MM-DD"));
      }
      this.daysSelectedLoading = daysRange;

      this.daysSelected = event;

      this.isValid = true;
      this.daysSelectedLoading = [];
    },
    handleClick() {
      const { adults, children, babies, itinerary } = this.$route.query;
      let { dateFrom, dateTo } = this.daysSelected
      const startDate = moment(dateFrom).format('YYYY-MM-DD');
      const endDate = moment(dateTo).format('YYYY-MM-DD');
      this.$router.push(`/mas-de-un-dia/${this.$route.params.origin}/${this.$route.params.destiny}/checkout/detalles?start=${startDate}&end=${endDate}&adults=${adults}&children=${children}&babies=${babies}&itinerary=${itinerary}&journey=true`);
    },
  },
  mounted() {
    this.days = this.$route.query.itinerary;
    const params = {
      origin: this.$route.params.origin,
      destiny: this.$route.params.destiny,
      adults: this.$route.query.adults,
      children: this.$route.query.children,
      babies: this.$route.query.babies,
      itinerary: this.$route.query.itinerary
    };
    this.$store
      .dispatch(FETCH_TRIPS, params)
      .then(() => {
        this.$store.dispatch(FETCH_INTERCONTINENTAL_FLIGHTS, params)
        this.destinyLabel = this.$route.params.destiny === "BKK" ? this.$t("shared.thailand") : this.$store.getters[GET_TRIP].destination.name;
      })
  },
}
</script>
